import { UnleashClient } from "unleash-proxy-client";

import { environment, featureProxyClientId, featureProxyUrl } from "./Environment";
import { setGitlabToggles } from "./feature";

interface FeatureToggles {
  isEnabled(toggleName: string): boolean;
}

export let featureToggles: FeatureToggles = dummyToggles();

export async function initFeatureToggles(userId: string) {
  if (featureProxyUrl && featureProxyClientId) {
    const unleash = unleashToggles();
    await unleash.updateContext({ userId });
    await unleash.start();
    featureToggles = unleash;

    setGitlabToggles(unleash.getAllToggles());
  }
}

function unleashToggles() {
  return new UnleashClient({
    url: featureProxyUrl,
    clientKey: featureProxyClientId,
    appName: environment,
    refreshInterval: 60 * 60 * 12, // update toggles after 12h
    disableMetrics: true,
  });
}

function dummyToggles() {
  return {
    isEnabled(_toggleName: string) {
      return false;
    },
  };
}
